import React from 'react';
import './ProgressBar.css';

function ProgressBar() {
  return (
    <div className='progress-bar'>
    
        <span className='percentage' />
      
    </div>
  )
}

export default ProgressBar
